// 唤起直营 sdk的统一出口方法

// import { Deserialize } from 'src/utils/serialization';
import cookies from 'src/utils/cookie';
import { StaticToast, StaticLoading } from 'src/components/common';
import { fetchJson, getChannelResourceCode, storage } from 'src/utils';
import { isObject } from 'src/utils/tool';
import validate from 'src/utils/validate';
import { fetch_channel_config } from 'src/store/config/action';
import { dmEnv, dmBridge } from '@dm/utils';
import { Modal } from 'zarm';

//必须保证windows全局事件名称不被污染
export const zaAppJSBridgeCallbackNameCreate = (funName) => `ZAJSSDK_${funName.toUpperCase()}_CALLBACK`;

//设置标题
export const setZaAppWebviewNavigationBarTitle = (title) => {
  const funName = 'setNavigationBarTitle';
  const closeCallbackName = zaAppJSBridgeCallbackNameCreate(funName); // 唤起视频sdk后，关闭当前的webview
  let paramsObj = {
    functionName: funName,
    params: {title},
    complete: closeCallbackName,
  };
  window[closeCallbackName] = (res) => {
    delete window[closeCallbackName];
  };
  window.prompt(JSON.stringify(paramsObj));
};

const refreshToken = (): Promise<any> => {
  const channelResourceCode = getChannelResourceCode();
  const token: string = cookies.get('za_token') || '';
  const fetchChannelConfig = (options: any, success: any) => window.globalStore.dispatch(fetch_channel_config(options, success));
  return new Promise((resolve) => {
    if (token) {
      resolve({ code: '0', channelResourceCode });
    } else {
      dmBridge.login('').then(() => {
        dmBridge.getZAToken().then((IBridgeResult) => {
          const { data: { token = '' } = {} } = IBridgeResult;
          fetchChannelConfig(
            {
              channelResourceCode,
              openId: token,
            },
            (res) => {
              const { code = '' } = res;
              resolve({ code, channelResourceCode });
            },
          );
        });
      });
    }
  });
};
export const jumpMyInquiry = () => {
  //如果已在问诊列表页，就不用进入该页面
  if (!/\/hospital\/my(mentalConsult|inquiry)/i.test(window.location.pathname)) {
    window.location.replace('/hospital/myinquiry'); //咨询相关 ，暂时不会涉及第三方，这里暂无影响
  }
};

export const closeZaAppWebView = () => {
  const funName = 'closeWebView';
  const closeCallbackName = zaAppJSBridgeCallbackNameCreate(funName); // 唤起视频sdk后，关闭当前的webview
  let paramsObj = {
    functionName: funName,
    params: {},
    complete: closeCallbackName,
  };
  //关闭后的回调
  window[closeCallbackName] = (res) => {
    // alert(JSON.stringify({ ...res, msg: 'closeWebView 回调' }));
    delete window[closeCallbackName];
  };

  window.prompt(JSON.stringify(paramsObj));
};
//唤起视频问诊sdk
const openZaAppOnlineConsultation = (params) => {
  /*
roomId String 腾讯IM sdk 房间id
sdkappid String 腾讯IM sdk addpid
userToken String 登录IM的userSig
userId String 登录IM 的用户ID
doctorId String	接诊医生id
inquiryNo String	问诊单号
*/
  const funName = 'startOnlineConsultation';
  const connectVideoSuccessCallbackName = zaAppJSBridgeCallbackNameCreate(funName); // 唤起sdk后，医生接诊进房间的回调
  const videoHangupCallbackName = zaAppJSBridgeCallbackNameCreate(`${funName}_videoHangup`); // 视频挂断后的回调
  let paramsObj = {
    functionName: funName,
    params: {
      ...params,
      videoHangUp: videoHangupCallbackName,
    },
    complete: connectVideoSuccessCallbackName,
  };
  storage.set('startOnlineParams', params, 120);
  window[videoHangupCallbackName] = (res) => {
    console.log('视频sdk挂断后的回调', res);
    const startOnlineParams = storage.get('startOnlineParams') || {};
    storage.set('startOnlineParams_end', { ...startOnlineParams, res, typeRes: typeof res }, 10);
    window.location.replace(res == '1' ? startOnlineParams.finishUrl : startOnlineParams.url);
    storage.remove('startOnlineParams');
    delete window[videoHangupCallbackName];
  };
  //接通后的回调
  window[connectVideoSuccessCallbackName] = (res) => {
    const { status = '', data = '' } = res; //data: { returnCode = '' } = {}
    if (status == '1' && (data === '0' || (isObject(data) && data.returnCode && data.returnCode === '0'))) {
      // closeZaAppWebView();
      // window.history.go(-(window.history.length - 1)); //不关闭webview,直接回退到webview打开的第一个页面
      console.log('startOnlineConsultation,调用成功，拉起视频问诊前回退到首页', window.history.length);
      return;
    } else {
      StaticToast.error('回调失败');
    }
    // alert(JSON.stringify({ ...res, msg: 'startOnlineConsultation 回调' }));
    jumpMyInquiry();
    delete window[connectVideoSuccessCallbackName];
  };

  window.prompt(JSON.stringify(paramsObj));
};

export const validateInquiryStatus = (inquiryStatus) => {
  if (![2, 3, 7].includes(inquiryStatus)) {
    //状态 依据问诊列表
    StaticToast.error('问诊已结束或异常！');
    jumpMyInquiry();
    return false;
  }
  return true;
};
export const openZaAppVideoSdkConsultation = async (inquiryId, inquiryNo) => {
  refreshToken().then(async (data) => {
    let { code = '', channelResourceCode = '' } = data;
    if (code !== '0') {
      window.reactHistory.replace({
        pathname: `/hospital/init`,
        search: `channelResourceCode=${channelResourceCode}&target=${encodeURIComponent('/hospital/home')}`,
      });
      return;
    }
    const res = await fetchJson({
      isloading: true,
      url: '/api/api/v1/patient/inquiry/detail',
      type: 'POST',
      data: {
        inquiryId,
        inquiryNo,
        option: {
          needPatient: true,
          needDiagnosis: true,
          needStaff: true,
          needThirdRelation: true,
        },
      },
    });
    if (res && res.code === '0') {
      const { result: { inquiryStatus = '', inquiryNo = '', id = '', medicalStaff: { staffName = '' } = {} } = {} } = res;
      if (validateInquiryStatus(inquiryStatus)) {
        fetchJson({
          url: '/api/api/v1/patient/video/inquiry/open',
          type: 'GET',
          data: {
            inquiryId,
            inquiryNo,
          },
          isloading: true,
          success: (res) => {
            if (res && res.code === '0') {
              let { platformCode = '' } = res.result || {};
              let zaLongToken = cookies.get('za_long_token');
              const urlBase = `${window.location.origin}/hospital`;
              openZaAppOnlineConsultation({
                user_type: 1,
                biz_type: 'INQUIRY',
                biz_no: inquiryNo,
                token: cookies.get('za_token') || zaLongToken || '',
                collectionFunction: Number(['UMP'].includes(platformCode)), //是否有收藏功能
                videoSupplier: platformCode,
                consultationUrl: `${urlBase}/video/chat?inquiryNo=${inquiryNo}&inquiryId=${id}`,
                finishUrl: `${urlBase}/umpEvaluate?inquiryId=${id}`, //问诊已结束
                url: `${urlBase}/myinquiry`, //问诊未结束
                title: `${staffName}  金牌医生`,
              });
            }
          },
        });
      } else {
        jumpMyInquiry();
      }
    } else {
      jumpMyInquiry();
    }
  });
};

export const CheckZaAudioPermissionConsultation = async () => {
  return new Promise((resolve) => {
    const funName = 'checkPermission';
    const audioPermissionCallbackName = zaAppJSBridgeCallbackNameCreate(funName);
    let audioParamsObj = {
      functionName: funName,
      params: {
        permission: 'RECORD_AUDIO',
      },
      complete: audioPermissionCallbackName,
    };
    //获取音频权限 0 无权限 1 有权限
    window[audioPermissionCallbackName] = (res) => {
      resolve(res);
      delete window[audioPermissionCallbackName];
    };
    window.prompt(JSON.stringify(audioParamsObj));
  });
};
export const CheckZaVideoPermissionConsultation = async () => {
  return new Promise((resolve) => {
    const funName = 'checkPermission';
    const videoPermissionCallbackName = zaAppJSBridgeCallbackNameCreate(`video${funName}`);
    let videoParamsObj = {
      functionName: funName,
      params: {
        permission: 'CAMERA',
      },
      complete: videoPermissionCallbackName,
    };
    //获取音频权限 0 无权限 1 有权限
    window[videoPermissionCallbackName] = (res) => {
      resolve(res);
      delete window[videoPermissionCallbackName];
    };
    window.prompt(JSON.stringify(videoParamsObj));
  });
};
export const newCheckZaAudioVideoPermissionConsultation = () => {
  return new Promise(async (resolve) => {
    //先调相机权限
    const videoRes: any = await CheckZaVideoPermissionConsultation();
    if (videoRes.status === '1') {
      console.log('相机授权回调', '相机:', videoRes.data.result);
      if (videoRes.data.result === '1') {
        //相机成功后再调麦克风权限
        const audioRes: any = await CheckZaAudioPermissionConsultation();
        if (audioRes.status === '1') {
          console.log('音频授权回调', '音频:', audioRes.data.result);
          if (audioRes.data.result === '1') {
            resolve(true);
          } else {
            console.log('音频授权回调失败', '音频:', audioRes.data.result);
            resolve(false);
          }
        } else {
          console.log('音频授权status不正确', '音频:', audioRes.status);
          resolve(false);
        }
      } else {
        console.log('相机授权回调不正确', '相机:', videoRes.data.result);
        resolve(false);
      }
    } else {
      console.log('相机授权回调status不正确', '相机:', videoRes.status);
      resolve(false);
    }
  });
};

/*
 * 授权失败时，弹窗提示用户去直营设置页设置权限
 */
export const openGotoGetPermissionConfirm = () => {
  const funName = 'pushToPhoneAction';
  const pushToPhoneActionCallbackName = zaAppJSBridgeCallbackNameCreate(funName);

  let pushToActionParamsObj = {
    functionName: funName,
    params: {
      openURL: 'app-settings://',
      page: 'setting',
    },
    complete: pushToPhoneActionCallbackName,
  };
  window[pushToPhoneActionCallbackName] = (data) => {
    console.log('pushToPhoneAction，方法回调', data);
    jumpMyInquiry(); //如果不在问诊列表页，则去问诊列表，否则停留在下单页会有问题！
    delete window[pushToPhoneActionCallbackName];
  };
  Modal.confirm({
    title: '设置权限',
    content: '是否前往设置页设置允许App获取音视频权限？',
    onOk: () => {
      window.prompt(JSON.stringify(pushToActionParamsObj));
    },
    onCancel: () => {
      //去我的问诊页
      jumpMyInquiry();
    },
  });
};
export const getAppSystemInfo = (version=371) => {
  return new Promise((resolve: (value: boolean) => void) => {
    if (!dmEnv.isApp()) {
      resolve(false);
      return;
    }
    try {
      dmBridge.getSystemInfo().then((res: any) => {
        if (res.status == 1) {
          let { data: { appVersion = '0' } = {} } = res;
          let ver = parseFloat(appVersion.replace(/-|\./g, ''));
          console.log(ver, ver >= version, 'data 版本结果');
          resolve(ver >= version);
          return;
        }
        resolve(false);
        console.log(res, '版本信息结果');
      });
    } catch (error) {
      resolve(false);
      console.log(error, '版本信息出错');
    }
  });
};

export default async (inquiryId, inquiryNo) => {
  StaticLoading.show();
  let appVerIsCanOnlineVideo = await getAppSystemInfo();
  if ((dmEnv.isApp() && appVerIsCanOnlineVideo) || validate.isBestpay()) { //直营APP 或 翼支付
    //直营入口没有上线，暂时屏蔽
    StaticLoading.hide();
    newCheckZaAudioVideoPermissionConsultation().then((res) => {
      if (res) {
        openZaAppVideoSdkConsultation(inquiryId, inquiryNo);
        return true;
      } else {
        openGotoGetPermissionConfirm();
        return false;
      }
    });
    return true;
  }
  StaticLoading.hide();
  return false;
};
